/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Trips_Notes_PlaceholderInputs */

const en_ui_trips_notes_placeholder = /** @type {(inputs: Ui_Trips_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes — useful info for later trips or friends (optional)`)
};

const de_ui_trips_notes_placeholder = /** @type {(inputs: Ui_Trips_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen — Hilfreiches für spätere Touren oder Freunde (optional)`)
};

/**
* | output |
* | --- |
* | "Notes — useful info for later trips or friends (optional)" |
*
* @param {Ui_Trips_Notes_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_trips_notes_placeholder = /** @type {((inputs?: Ui_Trips_Notes_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Trips_Notes_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_trips_notes_placeholder(inputs)
	return de_ui_trips_notes_placeholder(inputs)
});